export const getBusinessActivityKind = state => {
  return state.invoices.businessActivityKind;
};

export const getSavedPrivatePersonData = state => {
  return state.invoices.savedPrivatePersonData;
};

export const getSavedOtherBusinessData = state => {
  return state.invoices.savedOtherBusinessData;
};

export const getSavedSelfEmployedData = state => {
  return state.invoices.savedSelfEmployedData;
};

export const getSavedInvoicesEnabled = state => {
  return state.invoices.savedInvoicesEnabled;
};

export const getInvoiceCountries = state => {
  return state.invoices.invoiceCountries;
};

export const getLoading = state => {
  return state.invoices.loading;
};

export const getInvoiceFormData = state => {
  return state.invoices.invoiceFormData;
};

export const getInvoiceFormErrors = state => {
  return state.invoices.invoiceFormErrors;
};
